// extracted by mini-css-extract-plugin
export default {"wrapper":"Qy-z","viewport":"Ry-z","container":"Sy-z","slide":"Ty-z"};